// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/Roboto-Thin.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/Roboto-ThinItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/fonts/Roboto-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/fonts/Roboto-LightItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/fonts/Roboto-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/fonts/Roboto-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/fonts/Roboto-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../assets/fonts/Roboto-MediumItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../assets/fonts/Roboto-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../assets/fonts/Roboto-BoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../assets/fonts/Roboto-Black.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../assets/fonts/Roboto-BlackItalic.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Roboto";
  font-weight: 100;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 100;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 300;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 300;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 400;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 400;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 500;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 500;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 700;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 700;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 900;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 900;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("truetype");
}
.moveButtonsWrap {
  padding: 0 1rem;
  margin-top: 0.75rem;
}

.moveButtonsTitle {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  margin: 0 0 0.5rem;
  color: rgb(178, 181, 188);
  font-size: 0.8rem;
  font-weight: 600;
}
.moveButtonsTitle svg {
  color: #515592;
  opacity: 0.7;
}

.moveButtons {
  display: flex;
  justify-content: center;
  gap: 0.4rem;
  background-color: #f1f1f5;
  padding: 0.35rem;
  border-radius: 1rem;
}
.moveButtons button {
  flex: 1 1;
  box-sizing: border-box;
  cursor: pointer;
  border-radius: 0.7rem;
  height: 2.75rem;
  border: none;
  font-size: 0.9rem;
  font-weight: 600;
  background-color: transparent;
  color: #888;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
}
.moveButtons button:focus-visible {
  box-shadow: 0 0 0 2px rgba(81, 85, 146, 0.4);
}
.moveButtons button.selected {
  background-color: #ffffff;
  color: #515592;
  font-weight: 700;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
}
.moveButtons button:disabled {
  cursor: not-allowed;
  opacity: 0.3;
}
.moveButtons button:active:not(:disabled):not(.selected) {
  background-color: rgba(0, 0, 0, 0.05);
}`, "",{"version":3,"sources":["webpack://./src/assets/Theme/variables/_fonts.scss","webpack://./src/components/MoveButtons/MoveButtons.scss","webpack://./src/assets/Theme/variables/_colorSchema.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACCF;ADEA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACAF;ADGA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACDF;ADIA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACFF;ADKA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACHF;ADMA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACJF;ADOA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACLF;ADQA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACNF;ADSA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACPF;ADUA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACRF;ADWA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gEAAA;ACTF;ADYA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gEAAA;ACVF;AAnEA;EACE,eAAA;EACA,mBAAA;AAqEF;;AAlEA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,yBCbU;EDcV,iBAAA;EACA,gBAAA;AAqEF;AAnEE;EACE,cAlBY;EAmBZ,YAAA;AAqEJ;;AAjEA;EACE,aAAA;EACA,uBAAA;EACA,WAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;AAoEF;AAlEE;EACE,SAAA;EACA,sBAAA;EACA,eAAA;EACA,qBAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,6BAAA;EACA,WAAA;EACA,yBAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AAmEJ;AAjEI;EACE,4CAAA;AAmEN;AAhEI;EACE,yBCxDE;EDyDF,cAvDU;EAwDV,gBAAA;EACA,0CAAA;AAkEN;AA/DI;EACE,mBAAA;EACA,YAAA;AAiEN;AA9DI;EACE,qCAAA;AAgEN","sourcesContent":["@font-face {\n  font-family: 'Roboto';\n  font-weight: 100;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Thin.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 100;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-ThinItalic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 300;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Light.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 300;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-LightItalic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 400;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Regular.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 400;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-Italic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 500;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Medium.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 500;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-MediumItalic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 700;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Bold.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 700;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-BoldItalic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 900;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Black.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 900;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-BlackItalic.ttf') format('truetype');\n}\n","@import '../../assets/Theme/';\n\n$brand_primary: #515592;\n\n.moveButtonsWrap {\n  padding: 0 1rem;\n  margin-top: 0.75rem;\n}\n\n.moveButtonsTitle {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.35rem;\n  margin: 0 0 0.5rem;\n  color: $text_gray;\n  font-size: 0.8rem;\n  font-weight: 600;\n\n  svg {\n    color: $brand_primary;\n    opacity: 0.7;\n  }\n}\n\n.moveButtons {\n  display: flex;\n  justify-content: center;\n  gap: 0.4rem;\n  background-color: #f1f1f5;\n  padding: 0.35rem;\n  border-radius: 1rem;\n\n  button {\n    flex: 1;\n    box-sizing: border-box;\n    cursor: pointer;\n    border-radius: 0.7rem;\n    height: 2.75rem;\n    border: none;\n    font-size: 0.9rem;\n    font-weight: 600;\n    background-color: transparent;\n    color: #888;\n    transition: all 0.2s ease;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    outline: none;\n\n    &:focus-visible {\n      box-shadow: 0 0 0 2px rgba($brand_primary, 0.4);\n    }\n\n    &.selected {\n      background-color: $white;\n      color: $brand_primary;\n      font-weight: 700;\n      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);\n    }\n\n    &:disabled {\n      cursor: not-allowed;\n      opacity: 0.3;\n    }\n\n    &:active:not(:disabled):not(.selected) {\n      background-color: rgba(0, 0, 0, 0.05);\n    }\n  }\n}","$white: #ffffff;\n$text_dark: #2c2c2e;\n$text_gray: rgb(178, 181, 188);\n$buttonBg: #363c56;\n$errorText: #f70d1a;\n$buttonLinearBg: linear-gradient(to right, #1d2239, #4657a2, #1d2239);\n$msgDisable: rgb(150, 150, 150);\n$disabled: rgb(200, 200, 200);\n$light_gray: rgb(241, 241, 241);\n$unselectedText: rgb(80, 80, 80);\n$locationBnt: rgb(255, 255, 0);\n$spinner_blue: #3498db;\n\n$bg_unselected: rgb(188, 188, 224);\n$bg_selected: #559f5b;\n$bg_pending: #ccb137;\n$bg_frame: rgba(0, 0, 0, 0.6);\n\n$shadow: #2c2c2e5e;\n$light_shadow: rgba(49, 49, 52, 0.2);\n$highlighter: #eeff6e;\n$appt_bg: rgb(249, 249, 249);\n$red_bg: #cb101a;\n\n$notification_success: #4fae00;\n$notification_warning: #e4dd00;\n$notification_error: #be1000;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
